import React, { useEffect, useState } from "react";
import useFilters from "../../../hooks/useFilters";
import dayjs from "dayjs";
import { getLink, getOptionsForDropdown, getVendedoresForDropdown, permisions, renderEstadoBadge } from "../../../utils/helpers";
import IndexPageLayout from "../../general/CRUDLayout/IndexPageLayout";
import Select from "react-select"
import Modal from "../../general/Modal";
import { auth } from "../../../utils/auth";
import { Link } from "react-router-dom";
import Dropdown from "../../general/Dropdown";

const NotasDebito = () => {
    const [showCancel, setShowCancel] = useState(false);
    const [saving, setSaving] = useState(false);
    const [notaDebito, setNotaDebito] = useState({});
    const [triggerRequest, setTriggerRequest] = useState(0);
    const [numeraciones, setNumeraciones] = useState([]);
    const [vendedores, setVendedores] = useState([]);

    const { filters, handleFilterChange, filtersQuery } = useFilters({
        buscar: "",
        tipo: "venta",
        desde: dayjs().format("YYYY-MM-DD"),
        hasta: dayjs().format("YYYY-MM-DD"),
        estado: "",
    });

    const TABLE_COLUMNS = [
		{
			title: "NCF/Número",
			tdContent: (row) => <span>{row.numeracion}</span>,
		},
		{
			title: "Contacto",
			tdContent: (row) => <span>{row.contacto?.nombre}</span>,
		},
		{
			title: "Fecha",
			tdContent: (row) => <span>{dayjs(row.fecha).format("DD/MM/YYYY")}</span>,
		},
		{
			title: "Razón",
			tdContent: (row) => <span>{row.razon}</span>,
		},
		{
			title: "Factura afectada",
			tdContent: (row) => <span>{row.tipo === "venta" ? row.factura?.numero_comprobante : row.compra?.ncf || row.compra?.numero} </span>,
		},
		{
			title: "Total",
			tdContent: (row) => <span>{row.total}</span>,
		},
		{
			title: "Estado",
			tdContent: (row) => <div className="w-100 text-center">
                {renderEstadoBadge(row.estado)} <br/>

                <span className={`badge p-2 mt-1 ${row.cuadre_caja_id ? "badge-success" : "badge-secondary"}`} style={{width: "80px"}}>
                    {row.cuadre_caja_id ? "Cuadrada" : "Sin Cuadrar"}
                </span>
            </div>,
		},
		{
			title: "",
			tdContent: (row) => (
				<Dropdown>
					<Link
						to={getLink(`/imprimir/notas-debito/${row.id}`)}
						target="_blank"
						className="dropdown-item"
						title="Impresión normal"
					>
						Impresión
					</Link>

					{
						(row.estado !== "cancelada" && (
							<>
                                {!row.documento && (
                                    <Link
                                        to={getLink(`/ingresos/notas-debito/${row.id}/editar`)}
                                        className="dropdown-item"
                                        title="Editar"
                                    >
                                        Editar
                                    </Link>
                                )}
								<button
									onClick={() => toggleCancelModal(row)}
									className="dropdown-item"
									title="cancelar"
								>
									Cancelar
								</button>
							</>
						))
					}

					{row.notaFirmada?.length > 0 && <a
                        href={row.notaFirmada[0].url}
                        className="dropdown-item"
                        target="_blank" rel="noreferrer"
                    >
                        Nota Firmada
                    </a>}
				</Dropdown>
			),
		},
	];

    const toggleCancelModal = (notaDebito) => {
        setShowCancel(true);
        setNotaDebito(notaDebito);
    };

    const cancelNotaDebito = async (notaDebitoID) => {
        setShowCancel((state) => !state);
        setSaving(true);

        const response = await apiRequest(
            null,
            `notas-debito/${notaDebitoID}`,
            "DELETE"
        );

        if (response.success) {
            toast("Nota de Débito Cancelada", "success");
            setTriggerRequest((state) => state + 1);
            return;
        }
        toast("Error cancelando Nota de Débito", "error");

        setSaving(false);
    };

    useEffect(() => {
        getOptionsForDropdown('numeracion-documentos?tipo_documento=factura_venta').then((data) => {
            setNumeraciones(data);
        });

        getVendedoresForDropdown().then((data) => {
            setVendedores(data);
        });
    }, []);

    return <>
        <IndexPageLayout
            pageHeaderProps={{
                title: "Notas de Débito",
                hasButton: false,
                children: <HeaderChildren filtersQuery={filtersQuery} />,
            }}
            filters={{
                children: (
                    <Filters
                        handleFilterChange={handleFilterChange}
                        numeraciones={numeraciones}
                        filters={filters}
                        vendedores={vendedores}
                    />
                ),
            }}
            dataUrl={`notas-debito${filtersQuery}`}
            tableColumns={TABLE_COLUMNS}
            triggerRequest={triggerRequest}
            numeraciones={numeraciones}
        />

        {/* ---CONFIRMACIÓN CANCELAR FACTURA--- */}
        <Modal
            title={`Cancelar Nota de Débito ${notaDebito?.numeracion}`}
            show={showCancel}
            callback={() => cancelNotaDebito(notaDebito?.id)}
            acceptText="Aceptar"
            toggle={toggleCancelModal}
        >
            ¿Estás seguro de que deseas cancelar esta nota de débito? (Esta acción
            no se puede deshacer).
        </Modal>
    </>;
};

const HeaderChildren = ({ filtersQuery }) => {
	return (
		<>
			<div className="d-inline-block float-right h-100 d-flex align-items-center">
                <div className="dropdown m-r-10 d-none d-lg-inline-block">
                    <button className="au-btn au-btn-icon au-btn-filter">
						<i className="zmdi zmdi-print"></i> Reportes
					</button>
                    <ul
						style={{ right: "0", left: "auto" }}
						className="dropdown-menu"
					>
                        {auth.can(permisions.reporteNotaDebito) && <li>
                            <Link
                                to={getLink(`/imprimir/notas-debito${filtersQuery}`)}
                                target="_blank"
                                className="dropdown-item"
                            >
                                Reporte Notas Debito
                            </Link>
                        </li>}
                        {auth.can(permisions.reporteNotaDebitoDetalleImpuesto) && <li>
                            <Link
                                to={getLink(`/imprimir/notas-debito-detalles${filtersQuery}`)}
                                target="_blank"
                                className="dropdown-item"
                            >
                                Detalle de Impuestos
                            </Link>
                        </li>}
                    </ul>
                </div>
				<Link
					to={getLink(`/ingresos/notas-debito/crear`)}
					className="au-btn au-btn-icon au-btn--green au-btn--small m-r-15"
				>
					<i className="zmdi zmdi-plus" /> Añadir Nota de Débito
				</Link>
			</div>
		</>
	);
};

const Filters = ({ handleFilterChange, filters, numeraciones, vendedores }) => {
	return (
		<>
			<div className="col">
				<label>Buscar</label>
				<input
					type="search"
					placeholder="Buscar..."
					className="form-control"
					name="buscar"
					onChange={(e) =>
						handleFilterChange("buscar", e.target.value)
					}
				/>
			</div>

			<div className="col-12 col-md-6 col-lg-2">
			    <label>Estado</label>
				<Select
					name="estado"
                    isClearable
					isMulti
					onChange={(e) => {
                        handleFilterChange("estado", e);
                    }}
					options={[
						{ value: "completada", label: "Completada" },
						{ value: "cancelada", label: "Cancelada" },
					]}
				/>
			</div>

            {filters.tipo !== 'compra' && (
                <div className="col-12 col-md-6 col-lg-2">
                    <label>Numeración</label>
                    <Select
                        name="numeracion"
                        isClearable
                        isMulti
                        isDisabled={filters.tipo !== 'venta'}
                        onChange={(values) => handleFilterChange("numeracion", values)}
                        options={numeraciones}
                    />
                </div>
            )}

            {filters.tipo === 'compra' && (
                <div className="col-12 col-md-6 col-lg-2">
                    <label>Tipo Factura</label>
                    <Select
                        name="tipo_factura"
                        isClearable
                        onChange={(e) => handleFilterChange("tipo_factura", e?.value)}
                        options={[
                            {
                                label: "Todas",
                                value: "todas",
                            },
                            {
                                label: "Proforma",
                                value: "proforma",
                            },
                            {
                                label: "Comprobante Fiscal",
                                value: "comprobante",
                            },
                        ]}
                    />
                </div>
            )}

			<div className="col-12 col-md-6 col-lg-2 pr-lg-0">
				<label
					htmlFor="desde"
					style={{ fontSize: "12px", textTransform: "uppercase" }}
				>
					Desde
				</label>
				<input
					type="date"
					name="desde"
					id="desde"
					className="form-control"
					value={filters.desde}
					onChange={(e) =>
						handleFilterChange("desde", e.target.value)
					}
					// disabled={isVendedor()}
				/>
			</div>

			<div className="col-12 col-md-6 col-lg-2 pr-lg-0">
				<label
					htmlFor="hasta"
					style={{ fontSize: "12px", textTransform: "uppercase" }}
				>
					Hasta
				</label>
				<input
					type="date"
					name="hasta"
					id="hasta"
					defaultValue={filters.hasta}
					className="form-control"
					onChange={(e) =>
						handleFilterChange("hasta", e.target.value)
					}
					// disabled={isVendedor()}
				/>
			</div>

            <div className="col-12 col-md-6 col-lg-2">
                <label>Vendedor</label>
                <Select
                    name="vendedor"
                    isClearable
                    onChange={(values) => handleFilterChange("vendedor", values.value)}
                    options={vendedores}
                />
            </div>
		</>
	);
};

export default NotasDebito;
